import { render } from "./PreloadView.vue?vue&type=template&id=0e0c3485&ts=true"
import script from "./PreloadView.vue?vue&type=script&lang=ts"
export * from "./PreloadView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__